export default __webpack_public_path__ + "static/media/Pling.bd95cb61.mp3";